import { Grid, IconButton, Select, MenuItem, Table, TableBody
    , TableCell, TableRow, TextField, Typography, Box, InputLabel, FormControl } from '@mui/material';
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, add, remove
    , addSubDetalle, removeSubDetalle
    , setListPuntuacionDetalle
    , setValidations, activeValidations } from '../redux/puntuacionGrupoSlice';
import * as puntuacionService from "../services/puntuacionService";
import { FormHelperText as HelperText } from '@mui/material';

// Detalle 2 de la puntuacion: los grupos de la escala (puntuaciongrupo).
//
// Cada grupo tiene su subdetalle (puntuaciongrupodetalle): los
// puntuaciondetalle que lo forman. El subdetalle se edita debajo de la fila
// del grupo y se guarda junto con el.
const PuntuacionGrupo = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.puntuacionGrupo.entity);
    const defaultEntity = useSelector((state) => state.puntuacionGrupo.defaultEntity);
    const listPuntuacionDetalle = useSelector((state) => state.puntuacionGrupo.listPuntuacionDetalle);
    const validate = useSelector((state) => state.puntuacionGrupo.validationActive);
    const dispatch = useDispatch();
    // Fila del grupo cuyo subdetalle esta desplegado.
    const [abierto, setAbierto] = useState(0);

    var validation = {
        AtLeastOneRow: {
            error: entity.length == 1 && entity[0].id == 0,
            message: "Debe haber por lo menos un grupo",
        },
    }

    const idPuntuacion = parseInt(params.id || "0");

    const fetchEntity = useCallback(async () => {
        if (idPuntuacion <= 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        const grupos = await puntuacionService.getsPuntuacionGrupoPorPuntuacion(idPuntuacion)
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        if (grupos == null || grupos.length == 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        // Cada grupo trae su subdetalle, que se carga aparte.
        const conDetalle = [];
        for (const grupo of grupos) {
            const subdetalle = await puntuacionService.getsPuntuacionGrupoDetalle(grupo.id)
                .catch((err) => {
                    console.log("Err: ", err);
                    return [];
                });

            conDetalle.push({
                ...grupo,
                numero: grupo.id,
                puntuacionGrupoDetalle: (subdetalle || []).map((x) => ({ ...x })),
            });
        }

        dispatch(setEntity(conDetalle));
    }, [])

    const fetchListPuntuacionDetalle = useCallback(async () => {
        if (idPuntuacion <= 0) {
            dispatch(setListPuntuacionDetalle([]));
            return;
        }

        const data = await puntuacionService.getsPuntuacionDetalle(idPuntuacion)
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        dispatch(setListPuntuacionDetalle(data || []));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListPuntuacionDetalle();
    }, [])

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    const setItemValue = (numero, name, value) => {
        dispatch(setData({ numero: numero, name: name, value: value }))
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    // Texto del detalle elegido, para mostrarlo en el subdetalle.
    const textoDeDetalle = (idPuntuacionDetalle) => {
        const encontrado = listPuntuacionDetalle.find((x) => x.id === idPuntuacionDetalle);
        return encontrado == null ? "" : encontrado.texto + " (" + encontrado.descripcion + ")";
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Grupos de la escala (" + (entity != null ? entity.length : 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly || idPuntuacion <= 0} size="small" aria-label="Agregar Grupo"
                    style={{ height: 10 }} onClick={() => {
                        dispatch(add(idPuntuacion));
                    }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                <Table size="small">
                    <TableBody>
                        {entity.map((row, index) => (
                            <React.Fragment key={row.numero}>
                                <TableRow sx={(theme) => ({
                                    backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                    "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                                })}>
                                    <TableCell>
                                        <Grid container spacing={1} padding={0} alignItems={"center"}>
                                            <Grid item xs={12} sm={9}>
                                                <TextField
                                                    label="Descripcion del grupo"
                                                    fullWidth
                                                    value={row.descripcion}
                                                    onChange={(e) => {
                                                        setItemValue(row.numero, "descripcion", e.target.value)
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                    inputProps={{ maxLength: 70 }}
                                                />
                                            </Grid>
                                            <Grid item xs={1} sm={1}>
                                                <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                    dispatch(remove(row.numero));
                                                }}>
                                                    <IconDelete />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={2} sm={2}>
                                                <IconButton aria-label="toggle subdetalle" size="small"
                                                    onClick={() => {
                                                        setAbierto(abierto === row.numero ? 0 : row.numero);
                                                    }}>
                                                    <Typography variant="caption">
                                                        {"Valores: " + (row.puntuacionGrupoDetalle || []).length}
                                                    </Typography>
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                                {/* Subdetalle del grupo: los valores que lo forman. */}
                                {abierto === row.numero && (
                                    <TableRow>
                                        <TableCell colSpan={2} sx={{ backgroundColor: "#f5f5f5" }}>
                                            <Grid container spacing={1} padding={1}>
                                                {(row.puntuacionGrupoDetalle || []).length === 0 && (
                                                    <Grid item xs={12}>
                                                        <Typography variant="caption">
                                                            Este grupo todavia no tiene valores.
                                                        </Typography>
                                                    </Grid>
                                                )}
                                                {(row.puntuacionGrupoDetalle || []).map((sub, i) => (
                                                    <Grid item xs={12} sm={6} key={sub.numero}>
                                                        <Grid container spacing={1} alignItems={"center"}>
                                                            <Grid item xs={8}>
                                                                <Typography variant="body2">
                                                                    {i + 1}. {textoDeDetalle(sub.idPuntuacionDetalle)}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <IconButton aria-label="delete subdetalle" size="small"
                                                                    disabled={isReadOnly}
                                                                    onClick={() => {
                                                                        dispatch(removeSubDetalle({
                                                                            numero: row.numero,
                                                                            indice: i,
                                                                        }));
                                                                    }}>
                                                                    <IconDelete fontSize="small" />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                                {/* Agregar valor: solo lista los puntuaciondetalle
                                                    de la puntuacion actual, sin repetir los
                                                    que ya estan en el grupo. */}
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel id={"agregar-" + row.numero}>Agregar valor</InputLabel>
                                                        <Select
                                                            labelId={"agregar-" + row.numero}
                                                            label="Agregar valor"
                                                            value={0}
                                                            onChange={(e) => {
                                                                const id = parseInt(e.target.value);

                                                                if (id > 0) {
                                                                    dispatch(addSubDetalle({
                                                                        numero: row.numero,
                                                                        idPuntuacionDetalle: id,
                                                                    }));
                                                                }
                                                            }}
                                                            disabled={isReadOnly || listPuntuacionDetalle.length == 0}
                                                        >
                                                            <MenuItem value={0}>{"(Seleccione)"}</MenuItem>
                                                            {listPuntuacionDetalle
                                                                .filter((x) => !(row.puntuacionGrupoDetalle || [])
                                                                    .some((y) => y.idPuntuacionDetalle === x.id))
                                                                .map((x) => (
                                                                    <MenuItem key={x.id} value={x.id}>
                                                                        {x.texto} - {x.descripcion}
                                                                    </MenuItem>
                                                                ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        (validate.AtLeastOneRow && validation.AtLeastOneRow.error)
                    }>
                    <HelperText>
                        {validate.AtLeastOneRow && validation.AtLeastOneRow.error ? validation.AtLeastOneRow.message : ""}
                    </HelperText>
                </FormControl>
            </Grid>
        </Grid>
    )
}

export default PuntuacionGrupo;